module.exports = __webpack_public_path__ + "static/hero-bg-fb47261c94fff48f8a85d63a44bd0cfa.webp";